let areasCombined = [];

// --- DOM ELEMENTS ---
const lengthInput = document.getElementById('length-combined');
const widthInput = document.getElementById('width-combined');
const areaNameInput = document.getElementById('areaName-combined');
const wastageInput = document.getElementById('wastage-combined');
const boardWidthInput = document.getElementById('boardWidth-combined');
const addAreaBtn = document.getElementById('add-area-btn-combined');
const areasContainer = document.getElementById('areas-container-combined');
const errorMessage = document.getElementById('error-message-combined');
const subtotalAreaEl = document.getElementById('subtotal-area-combined');
const wastageAmountEl = document.getElementById('wastage-amount-combined');
const boardWidthDisplay = document.getElementById('board-width-display-combined');
const totalAreaEl = document.getElementById('total-area-combined');
const totalLinealMetersEl = document.getElementById('total-lineal-meters-combined');

// --- FUNCTIONS ---
function renderAreas() {
    if (areasCombined.length === 0) {
        areasContainer.innerHTML = `<p class="calc-empty-state">No areas added yet. Use the form above to add your first area.</p>`;
        return;
    }

    areasContainer.innerHTML = '';
    const list = document.createElement('ul');
    list.className = 'calc-areas-list';

    areasCombined.forEach((area, index) => {
        const listItem = document.createElement('li');
        listItem.className = 'calc-area-item';

        const areaText = document.createElement('span');
        areaText.className = 'calc-area-text';
        
        const displayName = area.areaName || `Area ${index + 1}`;
        areaText.textContent = `${displayName}: ${area.length}m x ${area.width}m = ${(area.length * area.width).toFixed(2)} m²`;

        const removeBtn = document.createElement('button');
        removeBtn.className = 'calc-remove-btn';
        removeBtn.innerHTML = '&#x2715;';
        removeBtn.title = `Remove ${displayName}`;
        removeBtn.onclick = () => removeArea(index);

        listItem.appendChild(areaText);
        listItem.appendChild(removeBtn);
        list.appendChild(listItem);
    });
    areasContainer.appendChild(list);
}

function calculateTotals() {
    // Calculate subtotal area (sum of all areas)
    const subtotal = areasCombined.reduce((acc, area) => acc + (area.length * area.width), 0);
    
    // Calculate wastage/cutting allowance
    const wastagePercent = parseFloat(wastageInput.value) || 0;
    const wastageAmount = subtotal * (wastagePercent / 100);
    
    // Calculate total m²
    const totalM2 = subtotal + wastageAmount;
    
    // Get board width in mm
    const boardWidthMm = parseFloat(boardWidthInput.value) || 83;
    
    // Calculate lineal meters using the formula: (m² / board_width_mm) * 100
    const totalLinealMeters = boardWidthMm > 0 ? (totalM2 / boardWidthMm) * 1000 : 0;

    // Update all displays
    subtotalAreaEl.textContent = `${subtotal.toFixed(2)} m²`;
    wastageAmountEl.textContent = `${wastageAmount.toFixed(2)} m²`;
    boardWidthDisplay.textContent = `${boardWidthMm} mm`;
    totalAreaEl.textContent = `${totalM2.toFixed(2)} m²`;
    totalLinealMetersEl.textContent = `${totalLinealMeters.toFixed(1)} Lm`;
}

function clearError() {
    errorMessage.textContent = '';
}

function addArea() {
    clearError();
    const length = parseFloat(lengthInput.value);
    const width = parseFloat(widthInput.value);
    const areaName = areaNameInput.value.trim();

    if (isNaN(length) || isNaN(width) || length <= 0 || width <= 0) {
        errorMessage.textContent = 'Please enter valid, positive numbers for length and width.';
        return;
    }

    areasCombined.push({ 
        length: length, 
        width: width, 
        areaName: areaName 
    });

    lengthInput.value = '';
    widthInput.value = '';
    areaNameInput.value = '';
    lengthInput.focus();

    renderAndUpdate();
}

function removeArea(index) {
    areasCombined.splice(index, 1);
    renderAndUpdate();
}

function renderAndUpdate() {
    renderAreas();
    calculateTotals();
}

// --- EVENT LISTENERS ---
if (addAreaBtn) addAreaBtn.addEventListener('click', addArea);
if (wastageInput) wastageInput.addEventListener('input', calculateTotals);
if (boardWidthInput) boardWidthInput.addEventListener('input', calculateTotals);

// Prevent scroll wheel from changing number input values only when focused
const numberInputs = [lengthInput, widthInput, wastageInput, boardWidthInput];
numberInputs.forEach(input => {
    if (input) {
        input.addEventListener('wheel', (e) => {
            // If the input is focused, blur it to allow page scrolling
            if (document.activeElement === input) {
                input.blur();
            }
        });
    }
});

if (lengthInput) {
    lengthInput.addEventListener('keydown', (e) => {
        clearError();
        if (e.key === 'Enter') {
            widthInput.focus();
        }
    });
}

if (widthInput) {
    widthInput.addEventListener('keydown', (e) => {
        clearError();
        if (e.key === 'Enter') {
            areaNameInput.focus();
        }
    });
}

if (areaNameInput) {
    areaNameInput.addEventListener('keydown', (e) => {
        clearError();
        if (e.key === 'Enter') {
            addArea();
        }
    });
}

// --- INITIAL RENDER ---
renderAndUpdate();